import meta from './meta';
import navbar from './navbar';

export default {
  ...meta,
  ...navbar,
  login: 'Log in',
  placeAnOrder: 'Place an order',
  pricePrefix: '${0}',
  pricePostfix: '{0}$',
};
